import { fetchRequestWrapper } from "@/lib/utilities";
import useReleaseNotesStore from "@/store/releaseNotesStore";
import useNotificationStore from "@/store/notificationStore";

export async function fetchLatestReleaseNotes(
  getAccessTokenSilently: Function,
) {
  try {
    const response = await fetchRequestWrapper(
      { url: "/ReleaseNotes/Latest" },
      getAccessTokenSilently,
    );

    if (!response || typeof response !== "object") return;
    if (!Array.isArray(response.notes) || response.notes.length === 0) return;

    const latestNote = response.notes[0];
    const date = typeof latestNote.date === "string" ? latestNote.date : "";
    const content =
      typeof latestNote.notes === "string" ? latestNote.notes : "";

    if (!date || !content) return;

    const store = useReleaseNotesStore.getState();
    store.setReleaseNote({ date, content });

    if (useReleaseNotesStore.getState().hasNewReleaseNote) {
      useNotificationStore
        .getState()
        .addNotification(
          "New release notes are available.",
          "ReleaseNotes",
          "",
        );
    }
  } catch {
    // Gracefully handle — never crash the app for release notes
  }
}
